import { createTheme } from '@mui/material/styles';

export const colors = {
  primaryNavy: '#0F172A',
  primaryBlue: '#1E3A8A',
  accentGreen: '#10B981',
  accentGreenHover: '#059669',
  bgApp: '#F8FAFC',
  bgSurface: '#FFFFFF',
  border: '#E2E8F0',
  textPrimary: '#0F172A',
  textSecondary: '#64748B',
  statusDraft: '#F59E0B',
  statusApproved: '#10B981',
  statusDeclined: '#EF4444',
  info: '#2563EB',
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primaryNavy,
      light: '#1E293B',
      dark: '#020617',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: colors.accentGreen,
      light: '#34D399',
      dark: colors.accentGreenHover,
      contrastText: '#FFFFFF',
    },
    success: { main: colors.accentGreenHover },
    warning: { main: colors.statusDraft },
    error: { main: colors.statusDeclined },
    info: { main: colors.info },
    background: {
      default: colors.bgApp,
      paper: colors.bgSurface,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    divider: colors.border,
  },
  typography: {
    fontFamily: '"DM Sans", "Segoe UI", sans-serif',
    h1: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.3 },
    h2: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
        containedSecondary: {
          backgroundColor: colors.accentGreen,
          '&:hover': { backgroundColor: colors.accentGreenHover },
        },
        containedPrimary: {
          backgroundColor: colors.primaryNavy,
          '&:hover': { backgroundColor: '#1E293B' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        outlined: { borderColor: colors.border },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: colors.bgApp,
            color: colors.textSecondary,
            fontWeight: 600,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: colors.border, padding: '12px 16px' },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: colors.bgSurface,
          '& fieldset': { borderColor: colors.border },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 6 },
      },
    },
  },
});
